import {Input, FormFeedback} from "reactstrap";
import React from "react";
import {t} from "i18next";

const CurrencyInput = ({name, value, onChange, register, errors}) => {
    return (
        <>
            <Input
                name={name}
                defaultValue={value || ''}
                invalid={!!errors[name]}
                innerRef={register({
                    required: true
                })}
                onChange={(e) => {
                    const regexp = /^\d+[.,]?(\d{1,2})?$/
                    if (!e.target.value.length || regexp.test(e.target.value)) {
                        let {name, value} = e.target;
                        value = value.replace(',', '.');
                        onChange({name, value});
                    }
                }}
            />
            {errors[name] && (
                <FormFeedback>
                    {t('inputs.validation.required')}
                </FormFeedback>
            )}
        </>
    );
}



export default CurrencyInput